/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import * as moment from 'moment';

import template from './report-list-page.component.html';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {APP_SHARED} from '../common/app-shared';
import {ReportExecutionApiService, ReportExecutionModel} from './report-execution-api.service';
import {ReportStatusComponent} from './report-status-component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, ...ADMIN_RESOURCE_PAGES, ReportStatusComponent],
  selector: 'adn-report-list-page',
  template
})
export class ReportListPageComponent implements OnInit {
  readonly showExecTime = ['adnuntius@adnuntius.com', 'broker1@adnuntius.com'].includes(inject(LocalUserProfile).get('username'));
  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {label: 'reportTemplate', param: '', sortable: false},
    {param: 'status'},
    {param: 'executionStartTime'},
    ...(this.showExecTime ? [{label: 'execTime', param: '', sortable: false}] : [])
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<ReportExecutionModel>(
    inject(ReportExecutionApiService),
    {
      listId: 'fullReportExecutionList',
      defaultOrderBy: 'executionStartTime',
      defaultAscending: false,
      nullsAsOldestParams: ['executionStartTime']
    },
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void { this.list.load(); }

  executionSeconds(report: ReportExecutionModel): number {
    return moment(report.executionEndTime).diff(moment(report.executionStartTime), 'seconds');
  }
}
